import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import useAuth from '../../../_core/hooks/useAuth'
import SignInModal from '../modals/signIn'
import SidebarWrapper from '../../../pages/auth/_components/profile/components/SidebarWrapper'
import PublicMobileNavbar from './mobileSideBar'
import Logo from '../../../assets/images/horizontal-logo.png'
import BreakpointRender from '../../../_core/components/breakpoint-render'

const Navbar: React.FC = () => {
  const [auth] = useAuth()
  const [visible, setVisible] = useState<boolean>(false)
  const [visibleCreate, setvisibleCreate] = useState<boolean>(false)
  const [showPref, setShowPref] = useState<boolean>(false)

  return (
    <>
      <SignInModal title={visibleCreate ? 'Create Account' : 'Sign In'} isCreateModal={visibleCreate} isVisible={visible || visibleCreate} onClose={() => {setvisibleCreate(false);setVisible(false); } } />
      <div className="nav">
        <div className="d-flex justify-content-between align-items-center w-100">

          <Link className="nav-link px-0" to="/">
            <BreakpointRender eq='desktop'>
              <img
                src="/assets/images/horizontal-logo.png"
                srcSet="/assets/images/horizontal-logo@2x.png 2x"
                alt="Dating Across the Pond"
              />
            </BreakpointRender>
            <BreakpointRender eq='mobile'>
              <img
                src="/assets/images/frog-datp-alfa-short-height.png"
                height={75}
                alt="Dating Across the Pond"
              />
            </BreakpointRender>
          </Link>

          <SidebarWrapper onHide={() => setShowPref(false)} visible={showPref} position="right" customHeader={<img src={Logo}/>}>
            <PublicMobileNavbar onSignIn={() => {setShowPref(false);setVisible(true)}} onCreate={() => {setShowPref(false); setvisibleCreate(true)}}/>
          </SidebarWrapper>
          <div className='pi pi-bars fw-bold d-md-none'
            style={{ fontSize: "2.2rem" }}
            onClick={() => setShowPref(true)}
          >
          </div>
          {
            <ul className="navbar-nav flex-row align-items-center d-none d-md-flex">
              <li className="nav-item">
                <Link className="nav-link px-3" to="/faq">
                  FAQ
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link px-3" to="/frequent-denial-reasons">
                  FDR
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link px-3" to="/stories">
                  Success Stories
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link px-3" to="/blog">
                  Blog
                </Link>
              </li>
              <li className="nav-item">
                <button className="nav-link px-3" onClick={() => setvisibleCreate(true)}>
                  Create Account
                </button>
              </li>
              <li className="nav-item">
              {
                auth.isAuthenticated
                ? <Link className="btn btn-primary px-3" to="/discover">Sign In</Link>
                : <button className="btn btn-primary" onClick={() => setVisible(true)}>Sign In</button>
              }
              </li>
            </ul>
          }
        </div>
      </div>
    </>
  )
}

export default Navbar
